import React, { useMemo } from "react";
import { useSiteContext } from "../../../state/SiteContext";

interface SiteConfigurationValueProps {
    name: string;
}

/**
 * Value source that returns a site configuration entry value by name (case-sensitive).
 * Missing or unknown name renders an empty string.
 */
export const SiteConfigurationValue = React.memo(function SiteConfigurationValue({
    name,
}: SiteConfigurationValueProps): React.ReactElement {
    const { siteState } = useSiteContext();

    const value = useMemo(() => {
        if (!name) {
            return "";
        }
        return siteState.site?.configuration?.find((entry) => entry.name === name)?.value ?? "";
    }, [name, siteState.site?.configuration]);

    return <>{value}</>;
});
